module.exports = __webpack_public_path__ + "img/6.02ee6908.jpg";